import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { createStore } from 'redux';
import {Provider} from 'react-redux';
import combineReducers from "../src/redux/reducers"

axios.defaults.baseURL = process.env.REACT_APP_API_NAME;
axios.defaults.headers.post['Content-Type'] = 'application/json';

const store = createStore(combineReducers);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
